import palette from "./palette";

export type ThemeType = typeof dark; // This is the type definition for my theme object.

export const dark = {
  primary: "#283cfa",
  primaryHover: "#2032e1",
  primaryActive: "#2e47e7",

  text: "#FFF",
  subText: "#cdcdcd",
  subTextDivider: "#8b8b8b",

  background: "#181818",
  inputText: palette.gray900,
  inputPlaceholder: palette.gray600,
  inputBackground: palette.gray200,
  inputShadow: palette.black15,

  modalOverlayBackground: "rgba(0, 0, 0, 0.7)",
  modalContentBackground: "#1b1b1b",

  closeButton: "#8b8b8b",
  closeButtonHover: "#cdcdcd",

  palette,
};

export const light: ThemeType = {
  primary: "#283cfa",
  primaryHover: "#2032e1",
  primaryActive: "#2e47e7",

  text: "#000",
  subText: "#000",
  subTextDivider: "#8b8b8b",

  background: "#fff",
  inputText: "#000",
  inputPlaceholder: "#000",
  inputBackground: "#fff",
  inputShadow: palette.black15,

  modalOverlayBackground: "rgba(0, 0, 0, 0.25)",
  modalContentBackground: "#fff",

  closeButton: "#8b8b8b",
  closeButtonHover: "#535353",

  palette,
};

export default light;
